const icon = (src, cls) =>
    src ? `<img src="${src}" class="${cls}" alt="" loading="lazy" onerror="this.remove()">` : "";

async function loadComponent(id, file) {
    const el = document.getElementById(id);
    if (!el) return;

    try {
        const res = await fetch(file);
        if (!res.ok) throw new Error(`${file} not found`);
        el.innerHTML = await res.text();
    } catch (e) {
        console.error(e);
    }
}
document.addEventListener("DOMContentLoaded", async () => {
    await Promise.all([
        loadComponent("header", "partials/header.html"),
        loadComponent("footer", "partials/footer.html")
    ]);

    await loadMenu();
    initNavigation();
    initStickyHeader();
});



async function loadMenu() {

    const nav = document.getElementById("mainMenu");
    if (!nav) return console.error("mainMenu not found");

    try {

        const menus = await (await fetch("assets/json/menu.json")).json();

        nav.innerHTML = menus.map(renderMenu).join("");

    } catch (e) {

        console.error(e);

    }

}
function renderMenu(menu) {

    switch (menu.type) {

        case "link":
            return `
                <li class="bn-nav-item">
                    <a href="${menu.url}" class="bn-nav-link">
                        ${icon(menu.icon,"bn-nav-icon")}
                        <span>${menu.title}</span>
                    </a>
                </li>`;

        case "dropdown":
            return `
                <li class="bn-nav-item bn-dropdown">
                    <a href="${menu.url || "javascript:void(0)"}" class="bn-nav-link">
                        ${icon(menu.icon,"bn-nav-icon")}
                        <span>${menu.title}</span>
                    </a>

                    <div class="bn-dropdown-menu">
                        ${menu.children.map(item=>`
                            <a href="${item.url}" class="bn-dropdown-item">
                                ${icon(item.icon,"bn-dropdown-icon")}
                                <span>${item.title}</span>
                            </a>
                        `).join("")}
                    </div>
                </li>`;

        case "mega":
            return `
                <li class="bn-nav-item bn-mega-wrapper">

                    <a href="${menu.url || "#"}" class="bn-nav-link">
                        ${icon(menu.icon,"bn-nav-icon")}
                        <span>${menu.title}</span>
                    </a>

                    <div class="bn-mega-menu bn-mega-menu-lg">

                        ${menu.columns.map(col=>`

                            <div class="bn-mega-menu-section">

                                <h6 class="bn-mega-menu-title">
                                    ${icon(col.icon,"bn-title-icon")}
                                    <span>${col.title}</span>
                                </h6>

                                <div class="bn-mega-menu-list">

                                    ${col.items.map(item=>`

                                        <a href="${item.url}" class="bn-mega-menu-item">
                                            ${icon(item.icon,"bn-item-icon")}
                                            <span>${item.title}</span>
                                        </a>

                                    `).join("")}

                                </div>

                            </div>

                        `).join("")}

                    </div>

                </li>`;

        default:
            return "";
    }

}
function initNavigation() {

    const current = location.pathname.split("/").pop() || "index.html";

    document
        .querySelectorAll(".bn-nav-link,.bn-dropdown-item,.bn-mega-menu-item")
        .forEach(link => {
            if (link.getAttribute("href")?.endsWith(current))
                link.classList.add("active");
        });

}

function initStickyHeader() {

    const header = document.getElementById("header");
    if (!header) return;

    const toggle = () =>
        header.classList.toggle("is-scrolled", scrollY > 20);

    toggle();
    addEventListener("scroll", toggle, { passive: true });

}